





































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
    return new proxy.HistoricalBillManageServiceProxy();
  }
  input :proxy.ChannelSupplierDayBillPageInputDto = new proxy.ChannelSupplierDayBillPageInputDto();
  createrange = [];
  PayChannels = []
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '供应商',
      key: 'name'
    },
    {
      title:'总跑',
      key:'money'
    },
    {
      title: '成功笔数',
      key: 'orderNum'
    },
    {
      title: '通道服务费',
      key: 'commission'
    },
    {
      title: '通道实到金额',
      key: 'payMoney'
    },
    {
      title: '结算时间',
      key: 'settlementTimeStr'
    },
    {
      title:'创建时间',
      key:'creationTime'
    }
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.prox.queryChannelSupplierModelList(this.input).then(x => {
      this.dataList = x.items;
      this.showPaging(x);
    });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    new proxy.ChannelSupplierServiceProxy().queryAllList().then((x) => {
      this.PayChannels = x;
    });
    this.getpage();
  }
}
